/**
 * File: defaultValues.js
 * Project: EXTA
 * File Created: Thursday, 30th May 2024 9:58:52 am
 * Author: Jorge Sierra Blázquez (jorge.sierra@aerin.es)
 * Version: 1.0.0
 * -----
 * Last Modified: Tuesday, 27th August 2024 11:23:43 am
 * Modified By: Ricardo Fernández Cuesta
 * -----
 * Copyright (c) 2023 - 2024 Aerin Sistemas S. L. copying, distribution or modification not authorised in writing is prohibited.
 *
 */

/*
IMPORTANTE: No editar este archivo en noname-base-frontend 
debido a que al copiar el modulo este lo reemplazara.
*/
// import {filterUrls} from "helpers/Utils";

export const UserRole = {
  Admin: 0,
  Editor: 1,
};

/* 
Menu Types:
"menu-default", "menu-sub-hidden", "menu-hidden"
*/
export const defaultMenuType = 'menu-hidden';

// Variable de la paginación de tablas
export const defaultMaxSize = 8;

export const subHiddenBreakpoint = 1440;
export const menuHiddenBreakpoint = 768;
export const defaultLocale = 'es';
export const localeOptions = [
  { id: 'es', name: 'Español', direction: 'ltr' },
  { id: 'en', name: 'English', direction: 'ltr' },
];

export const firebaseConfig = {
  apiKey: 'AIzaSyBBksq-Asxq2M4Ot-75X19IyrEYJqNBPcg',
  authDomain: 'gogo-react-login.firebaseapp.com',
  databaseURL: 'https://gogo-react-login.firebaseio.com',
  projectId: 'gogo-react-login',
  storageBucket: 'gogo-react-login.appspot.com',
  messagingSenderId: '216495999563',
};

export const currentUser = {
  id: 1,
  title: 'Sarah Kortney',
  img: '/assets/img/profiles/l-1.jpg',
  date: 'Last seen today 15:24',
  role: UserRole.Admin,
};

export const adminRoot = '/app';
export const databaseSelected = ''; // 'exta';
export const loginRoot = '/user/login';
export const permissionDenied = '/app/home/homedashboard';

export const buyUrl = 'https://1.envato.market/k4z0';
export const searchPath = `${adminRoot}/pages/miscellaneous/search`;
export const servicePath = 'https://api.coloredstrategies.com';

export const themeColorStorageKey = '__theme_selected_color';
export const isMultiColorActive = false;
export const defaultColor = 'dark.exta';
export const isDarkSwitchActive = true;
export const defaultDirection = 'ltr';
export const themeRadiusStorageKey = '__theme_radius';
export const isAuthGuardActive = false;
export const colors = [
  /*
  'bluenavy',
  'blueyale',
  'blueolympic',
  'greenmoss',
  'greenlime',
  'purplemonster',
  'orangecarrot',
  'redruby',
  'yellowgranola',
  'greysteel',
  */
  'bluenoname',
  'pinknoname',
  'greennoname',
  'orangenoname',
];
export const adminMenus = [''];
export const customFilter = '';
export const actualRedirect = '/home';
// TODO METER EL CUSTOMFILTER EN EL DEFAULT VALUES DE NONAME-BASE-FRONTEND
